import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
export type HeaderMenuItem = {
  id?: string;
  label: string;
  caption?: string;
  link?: string;
  iconSrc?: string;
  action?: () => void;
  items?: HeaderMenuItem[];
  featured?: boolean;
  topLabel?: string;
};

@Component({
  selector: 'header-menu-item',
  templateUrl: './header-menu-item.component.html',
  styleUrls: ['./header-menu-item.component.scss'],
  standalone: false,
})
export class HeaderItemComponent implements OnInit {
  @Input()
  public readonly menuItem: HeaderMenuItem;

  @Input()
  public readonly root: boolean;

  @Input()
  public readonly active: boolean;

  @Output() toggleMenuItem = new EventEmitter<string>();

  @HostBinding('class') class = 'header-menu-item-host';
  @HostBinding('class.featured') featuredClass = false;
  @HostBinding('class.has-items') hasItemsClass = false;

  constructor() {}

  ngOnInit() {
    this.featuredClass = !!this.menuItem.featured;
    this.hasItemsClass = this.menuItem.items?.length > 0;
  }

  public toggle(): void {
    this.toggleMenuItem.emit(this.menuItem.id);
  }

  public rootHasSubMenu(): boolean {
    return this.root && this.menuItem.items?.some((m) => m.items?.length);
  }
}
